import { getOptions } from "./variables"

export function falsesubmit(obj) {
  const { focuselements } = getOptions()
  let flag
  let movefocus = null

  for (i = 0; i < obj.length; i++) {
    if (flag && obj.elements[i].type != "hidden") {
      movefocus = obj.elements[i]
      flag = 0
    }
    if (obj.elements[i] === focuselements) {
      flag = 1
    }
  }
  if (movefocus !== null && typeof movefocus.focus === "function")
    movefocus.focus()
  return false
}

export function mfp_disp(objId, dispMsg) {}
